import './ServiceRequestChangePhone.css';

import {
  getServiceRequestDetailsAction,
  pushViewAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {postAPICall} from '../../../services/apiCallsHandler';
import {enqueueToastUI, replaceTranslations} from '../../../utils/util';

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useToastProvider,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import countrySpecificConfig from './ServiceRequestChangePhoneConfig.json';

const ServiceRequestChangePhone = (props) => {
  const {t} = useTranslation();
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [otpCode, setOtpCode] = React.useState('');
  const [otpSent, setOtpSent] = React.useState(false);
  const [submitDisabled, setSubmitDisabled] = React.useState(true);
  const [verifyEmailDisabled, setVerifyEmailDisabled] = React.useState(true);
  const [loader, setLoader] = React.useState(false);
  const [verifyLoader, setVerifyLoader] = React.useState(false);
  const [numberType, setNumberType] = React.useState(
    props.selectedNumberType ?? null
  );
  const phoneLength = countrySpecificConfig[props.country]?.phone?.maxLength;
  const {enqueueToast} = useToastProvider();

  const onChangeHandler = (e) => {
    const cleanedValue = e.target.value.replaceAll(/\D/g, '');
    setPhoneNumber(cleanedValue);

    if (e.target.value.length === phoneLength) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  };

  const radioButtonHandler = (e) => {
    setNumberType(e.target.value);
  };

  const otpChangeHandler = (e) => {
    const cleanedValue = e.replaceAll(/\D/g, '');
    setOtpCode(cleanedValue);

    if (e.length === 6) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  };

  const emailChangeHandler = (e) => {
    setEmail(e);
    if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(e)) {
      setVerifyEmailDisabled(false);
    } else {
      setVerifyEmailDisabled(true);
    }
  };

  const sendOtptoUser = () => {
    setVerifyLoader(true);
    postAPICall(
      'otp/send',
      {
        oktaUserId: props.oktaUserId?.userID,
        otpPreference: ['email'],
        emailIds: email,
        language: 'en',
      },
      {
        errorTag: 'CONTACT_CALLBACK_MODAL',
      }
    ).then((res) => {
      setVerifyLoader(false);
      if (res.status == 200) {
        setOtpSent(true);
      } else if (res.status === 429) {
        enqueueToastUI(res.status, enqueueToast, null, t('OTP_LIMIT'));
      }
    });
  };

  const phoneSubmitHandler = () => {
    const reqBody = {};
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }
    reqBody.contractNumber = props.contractNumber;
    reqBody.updatedPhone = phoneNumber;
    reqBody.requestType = 'Change Phone';
    reqBody.numberType = numberType;
    reqBody.countryCode = props.country;
    reqBody.userEmail = props.oktaUserId.email;
    setSubmitDisabled(true);
    setLoader(true);
    postAPICall(
      'serviceRequest',
      {
        ...reqBody,
      },
      {
        errorTag: 'CHANGE_PHONE_SERVICE_REQUEST',
      }
    ).then((res) => {
      setLoader(false);
      setSubmitDisabled(false);

      if (res.status === 429) {
        enqueueToastUI(
          res.status,
          enqueueToast,
          null,
          replaceTranslations(t('SERVICE_REQUEST_LIMIT'), 10, t('Change_Phone'))
        );
      } else {
        enqueueToastUI(
          res.status,
          enqueueToast,
          t('SERVICE_REQUEST_SUCCESS'),
          t('SERVICE_REQUEST_CREATION_FAILED')
        );
      }
      if (res.status == 200) {
        appStore.dispatch(getServiceRequestDetailsAction(null));
        appStore.dispatch(pushViewAction('serviceRequestDashboard'));
      }
    });
  };

  const emailSubmitHandler = () => {
    const reqBody = {};
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }
    reqBody.contractNumber = props.contractNumber;
    reqBody.otp = otpCode;
    reqBody.requestType = 'Change Email';
    reqBody.countryCode = props.country;
    reqBody.userEmail = props.oktaUserId.email;
    setSubmitDisabled(true);
    setLoader(true);
    postAPICall(
      'serviceRequest',
      {...reqBody},
      {
        errorTag: 'CHANGE_EMAIL_SERVICE_REQUEST',
      }
    ).then((res) => {
      setLoader(false);
      setSubmitDisabled(false);
      if (res.status === 429) {
        if (res.body && res.body?.isVerified === false) {
          enqueueToastUI(res.status, enqueueToast, null, t('OTP_Limit_Exceed'));
        } else {
          enqueueToastUI(
            res.status,
            enqueueToast,
            null,
            replaceTranslations(
              t('SERVICE_REQUEST_LIMIT'),
              10,
              t('Change_Email')
            )
          );
        }
      } else {
        enqueueToastUI(
          res.status,
          enqueueToast,
          t('SERVICE_REQUEST_SUCCESS'),
          t('SERVICE_REQUEST_CREATION_FAILED')
        );
      }
      if (res.status == 200) {
        appStore.dispatch(getServiceRequestDetailsAction(null));
        appStore.dispatch(pushViewAction('serviceRequestDashboard'));
      }
    });
  };

  const renderChangePhone = () => {
    return (
      <div className={'ServiceRequestChangePhoneWrapper'}>
        <div className={'ServiceRequestCard'}>
          <div className="serviceRequestHeader">
            <div className={'title'}>{t('CHANGE_PHONE_NUMBER')}</div>
          </div>
          <div className={'subTitle'}>{t('CHANGE_PHONE_NUMBER_SUBTITLE')}</div>
        </div>
        <Box pl={4} pr={4} pb={4}>
          <Card className="cardCustom">
            <CardContent className="ChangePhoneCard">
              <Typography gutterBottom variant="h5" required={true}>
                {t('TYPE_OF_NUMBER')}
                <span className="requiredText">*</span>
              </Typography>
              <RadioGroup
                name="group1"
                data-testid="radio-button-id"
                className="phoneNumberType"
                defaultValue={numberType ?? ''}
                onClick={(phoneNumberType) =>
                  radioButtonHandler(phoneNumberType)
                }
              >
                <FormControlLabel
                  control={<Radio />}
                  label={t('PHONE_NUMBER')}
                  value="Phone Number"
                />
                <FormControlLabel
                  control={<Radio />}
                  label={t('LANDLINE_NUMBER')}
                  value="Landline Number"
                />
              </RadioGroup>
              <TextField
                className="ChangePhoneTextField"
                label={t('CHANGE_PHONE_NUMBER_TEXTFIELD')}
                type="text"
                data-testid="change-phone-number"
                required={true}
                value={phoneNumber}
                size="small"
                onChange={(e) => {
                  if (e.target.value.length <= phoneLength) {
                    onChangeHandler(e);
                  }
                }}
              />
            </CardContent>
          </Card>
          <div className="buttonControls">
            <Button
              id="cancelButton"
              onClick={() => props.cancelButtonClick(null)}
              variant="secondary"
            >
              {t('CANCEL')}
            </Button>

            <Button
              id="phonePrimaryBtn"
              onClick={() => phoneSubmitHandler()}
              variant="primary"
              disabled={numberType ? submitDisabled : true}
              startIcon={
                loader && (
                  <CircularProgress size="small" style={{color: '#000'}} />
                )
              }
            >
              {t('SUBMIT')}
            </Button>
          </div>
        </Box>
      </div>
    );
  };

  const renderChangeEmail = () => {
    return (
      <div className={'ServiceRequestChangePhoneWrapper'}>
        <div className={'ServiceRequestCard'}>
          <div className="serviceRequestHeader">
            <div className={'title'}>{t('CHANGE_EMAIL_ID')}</div>
          </div>
          <div className={'subTitle'}>{t('CHANGE_EMAIL_ID_SUBTITLE')}</div>
        </div>
        <Box pl={4} pr={4} pb={4}>
          <Card className="emailCardCustom">
            <div className="changeEmailCard">
              <CardContent className="ChangePhoneCard">
                <TextField
                  className="ChangePhoneTextField"
                  label={t('CHANGE_EMAIL_ID_TEXTFIELD')}
                  type="email"
                  data-testid="change-email-id"
                  required={false}
                  value={email}
                  size="small"
                  disabled={verifyLoader || otpSent}
                  onChange={(e) => {
                    emailChangeHandler(e.target.value);
                  }}
                />
              </CardContent>

              <Button
                id="verifyNumber"
                variant="text"
                disabled={verifyEmailDisabled || otpSent}
                onClick={() => sendOtptoUser()}
                startIcon={
                  verifyLoader && (
                    <CircularProgress size="small" style={{color: '#000'}} />
                  )
                }
              >
                {t('VERIFY_EMAIL')}
              </Button>
            </div>
            {otpSent && (
              <div className="changeEmailCard">
                <CardContent className="ChangePhoneCard">
                  <TextField
                    helperText={t('CODE_HELPER_TEXT')}
                    className="ChangePhoneTextFieldOTP"
                    label={t('VERIFICATION_CODE')}
                    type="text"
                    data-testid="change-email-otp"
                    required={false}
                    value={otpCode}
                    size="small"
                    onChange={(e) => {
                      if (e.target.value.length <= 6) {
                        otpChangeHandler(e.target.value);
                      }
                    }}
                  />
                </CardContent>
                <Button
                  id="resendOtp"
                  variant="text"
                  disabled={!email}
                  onClick={() => sendOtptoUser()}
                  startIcon={
                    verifyLoader && (
                      <CircularProgress size="small" style={{color: '#000'}} />
                    )
                  }
                >
                  {t('RESEND_CODE')}
                </Button>
              </div>
            )}
          </Card>
          <div className="buttonControls">
            <Button
              id="cancelButton"
              onClick={() => props.cancelButtonClick(null)}
              variant="secondary"
            >
              {t('CANCEL')}
            </Button>

            <Button
              id="primaryBtn"
              onClick={() => emailSubmitHandler()}
              variant="primary"
              disabled={submitDisabled}
              startIcon={
                loader && (
                  <CircularProgress size="small" style={{color: '#000'}} />
                )
              }
            >
              {t('SUBMIT')}
            </Button>
          </div>
        </Box>
      </div>
    );
  };

  return (
    <>
      {props.view === 'changePhone' ? renderChangePhone() : renderChangeEmail()}
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    oktaUserId: state.appStates.userDetailsInfo,
    country: state.appStates.allContracts?.countryCode,
  };
};
export default connect(mapStateToProps)(ServiceRequestChangePhone);
